var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-sidebar",
    {
      ref: "sidebar_fields",
      attrs: {
        id: _vm.sidebarFields,
        "sidebar-class": "custom-sidebar-container sidebar-fields",
        title: "Настройка колонок",
        right: "",
        shadow: "",
        backdrop: ""
      },
      on: { hidden: _vm.onHidden }
    },
    [
      _c("div", { staticClass: "d-flex flex-column h-100" }, [
        _c(
          "div",
          { staticClass: "flex-grow-1 overflow-auto p-3" },
          [
            !_vm.configureRequired &&
            (_vm.isDragging || _vm.fieldsLeft.length > 0)
              ? _c(
                  "div",
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "font-weight-bold text-small text-muted mb-2 mt-1"
                      },
                      [_vm._v("ЗАКРЕПЛЕНЫ СЛЕВА")]
                    ),
                    _vm._v(" "),
                    _c(
                      "draggable",
                      {
                        staticClass: "drag-zone",
                        class: {
                          "drop-placeholder-active":
                            _vm.isDragging && _vm.fieldsLeft.length === 0
                        },
                        attrs: { group: "columns", handle: ".drag-handle" },
                        on: {
                          start: function($event) {
                            _vm.isDragging = true
                          },
                          end: function($event) {
                            _vm.isDragging = false
                          }
                        },
                        model: {
                          value: _vm.fieldsLeft,
                          callback: function($$v) {
                            _vm.fieldsLeft = $$v
                          },
                          expression: "fieldsLeft"
                        }
                      },
                      _vm._l(_vm.fieldsLeft, function(field) {
                        return _c(
                          "div",
                          {
                            key: field.id,
                            staticClass: "export-list-item mb-1"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center text-truncate"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "drag-handle text-dark mr-2" },
                                  [
                                    _c("v-icon", {
                                      attrs: { name: "buttons/dots", size: 12 }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-secondary mr-2 cursor-pointer",
                                    attrs: { title: "Открепить" },
                                    on: {
                                      click: function($event) {
                                        return _vm.unpinField(field)
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", {
                                      attrs: { name: "buttons/pin", size: 13 }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "text-small" }, [
                                  _vm._v(_vm._s(field.label))
                                ]),
                                _vm._v(" "),
                                _vm.configureRequired &&
                                field.required &&
                                field.visible
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-danger font-weight-bold ml-2"
                                      },
                                      [_vm._v("*")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-items-center",
                                staticStyle: { gap: "12px" }
                              },
                              [
                                _vm.configureRequired
                                  ? _c("b-form-checkbox", {
                                      staticClass: "m-0",
                                      attrs: { disabled: !field.visible },
                                      model: {
                                        value: field.required,
                                        callback: function($$v) {
                                          _vm.$set(field, "required", $$v)
                                        },
                                        expression: "field.required"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ant-switch-wrapper",
                                    class: {
                                      "is-disabled":
                                        _vm.visibleFields.length === 1 &&
                                        field.visible
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleField(field)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "pure-switch-track",
                                      class: { "is-checked": field.visible }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "switch-icons-overlay" },
                                      [
                                        _c("v-icon", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: field.visible,
                                              expression: "field.visible"
                                            }
                                          ],
                                          staticClass: "ml-2",
                                          staticStyle: { color: "#fff" },
                                          attrs: {
                                            name: "buttons/check",
                                            size: 11
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !field.visible,
                                              expression: "!field.visible"
                                            }
                                          ],
                                          staticClass: "flex-grow-1"
                                        }),
                                        _vm._v(" "),
                                        _c("v-icon", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !field.visible,
                                              expression: "!field.visible"
                                            }
                                          ],
                                          staticClass: "mr-2",
                                          staticStyle: { color: "#fff" },
                                          attrs: {
                                            name: "buttons/cross",
                                            size: 10
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "pure-switch-thumb",
                                      class: { "is-checked": field.visible }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.allowDelete && !field.isSeparator
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "position-relative d-flex align-items-center ml-2"
                                      },
                                      [
                                        _c("v-icon", {
                                          staticClass: "cursor-pointer",
                                          attrs: {
                                            id: "delete-btn-left-" + field.key,
                                            name: "buttons/trash",
                                            size: 14
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "b-popover",
                                          {
                                            attrs: {
                                              target:
                                                "delete-btn-left-" + field.key,
                                              triggers: "click blur",
                                              placement: "left",
                                              container: "sidebarFields"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-small font-weight-bold mb-2"
                                              },
                                              [_vm._v("Удалить колонку?")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "d-flex",
                                                staticStyle: { gap: "8px" }
                                              },
                                              [
                                                _c(
                                                  "b-btn",
                                                  {
                                                    staticClass:
                                                      "custom-btn-primary btn-sm",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.onDeleteKanbanCol(
                                                          field,
                                                          "left"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Да")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-btn",
                                                  {
                                                    staticClass:
                                                      "custom-btn-secondary btn-sm",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.$root.$emit(
                                                          "bv::hide::popover",
                                                          "delete-btn-left-" +
                                                            field.key
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Нет")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.configureRequired
              ? _c(
                  "div",
                  {
                    staticClass:
                      "font-weight-bold text-small text-muted mb-2 mt-3"
                  },
                  [_vm._v("ТАБЛИЦА")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "draggable",
              {
                staticClass: "drag-zone",
                attrs: { group: "columns", handle: ".drag-handle" },
                on: {
                  start: function($event) {
                    _vm.isDragging = true
                  },
                  end: function($event) {
                    _vm.isDragging = false
                  }
                },
                model: {
                  value: _vm.fieldsCenter,
                  callback: function($$v) {
                    _vm.fieldsCenter = $$v
                  },
                  expression: "fieldsCenter"
                }
              },
              _vm._l(_vm.fieldsCenter, function(field) {
                return _c(
                  "div",
                  { key: field.id, staticClass: "export-list-item mb-1" },
                  [
                    field.isSeparator
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "font-weight-bold text-small text-muted text-uppercase p-2 my-1 w-100"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(field.label) +
                                "\n          "
                            )
                          ]
                        )
                      : [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center text-truncate"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "drag-handle text-dark mr-2" },
                                [
                                  _c("v-icon", {
                                    attrs: { name: "buttons/dots", size: 12 }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.configureRequired
                                ? _c(
                                    "span",
                                    { staticClass: "text-secondary mr-2" },
                                    [
                                      _c("v-icon", {
                                        attrs: {
                                          name: "buttons/unpin",
                                          size: 13
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(_vm._s(field.label))
                              ]),
                              _vm._v(" "),
                              _vm.configureRequired &&
                              field.required &&
                              field.visible
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-danger font-weight-bold ml-2"
                                    },
                                    [_vm._v("*")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex align-items-center",
                              staticStyle: { gap: "12px" }
                            },
                            [
                              _vm.configureRequired
                                ? _c("b-form-checkbox", {
                                    staticClass: "m-0",
                                    attrs: { disabled: !field.visible },
                                    model: {
                                      value: field.required,
                                      callback: function($$v) {
                                        _vm.$set(field, "required", $$v)
                                      },
                                      expression: "field.required"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "ant-switch-wrapper",
                                  class: {
                                    "is-disabled":
                                      _vm.visibleFields.length === 1 &&
                                      field.visible
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleField(field)
                                    }
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "pure-switch-track",
                                    class: { "is-checked": field.visible }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "switch-icons-overlay" },
                                    [
                                      _c("v-icon", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: field.visible,
                                            expression: "field.visible"
                                          }
                                        ],
                                        staticClass: "ml-2",
                                        staticStyle: { color: "#fff" },
                                        attrs: {
                                          name: "buttons/check",
                                          size: 11
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !field.visible,
                                            expression: "!field.visible"
                                          }
                                        ],
                                        staticClass: "flex-grow-1"
                                      }),
                                      _vm._v(" "),
                                      _c("v-icon", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !field.visible,
                                            expression: "!field.visible"
                                          }
                                        ],
                                        staticClass: "mr-2",
                                        staticStyle: { color: "#fff" },
                                        attrs: {
                                          name: "buttons/cross",
                                          size: 10
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "pure-switch-thumb",
                                    class: { "is-checked": field.visible }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _vm.allowDelete && !field.isSeparator
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "position-relative d-flex align-items-center ml-2"
                                    },
                                    [
                                      _c("v-icon", {
                                        staticClass: "cursor-pointer",
                                        attrs: {
                                          id: "delete-btn-center-" + field.key,
                                          name: "buttons/trash",
                                          size: 14
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-popover",
                                        {
                                          attrs: {
                                            target:
                                              "delete-btn-center-" + field.key,
                                            triggers: "click blur",
                                            placement: "left",
                                            container: "sidebarFields"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-small font-weight-bold mb-2"
                                            },
                                            [_vm._v("Удалить колонку?")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex",
                                              staticStyle: { gap: "8px" }
                                            },
                                            [
                                              _c(
                                                "b-btn",
                                                {
                                                  staticClass:
                                                    "custom-btn-primary btn-sm",
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.onDeleteKanbanCol(
                                                        field,
                                                        "center"
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Да")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-btn",
                                                {
                                                  staticClass:
                                                    "custom-btn-secondary btn-sm",
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.$root.$emit(
                                                        "bv::hide::popover",
                                                        "delete-btn-center-" +
                                                          field.key
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Нет")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                  ],
                  2
                )
              }),
              0
            ),
            _vm._v(" "),
            !_vm.configureRequired &&
            (_vm.isDragging || _vm.fieldsRight.length > 0)
              ? _c(
                  "div",
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "font-weight-bold text-small text-muted mb-2 mt-3"
                      },
                      [_vm._v("ЗАКРЕПЛЕНЫ СПРАВА")]
                    ),
                    _vm._v(" "),
                    _c(
                      "draggable",
                      {
                        staticClass: "drag-zone",
                        class: {
                          "drop-placeholder-active":
                            _vm.isDragging && _vm.fieldsRight.length === 0
                        },
                        attrs: { group: "columns", handle: ".drag-handle" },
                        on: {
                          start: function($event) {
                            _vm.isDragging = true
                          },
                          end: function($event) {
                            _vm.isDragging = false
                          }
                        },
                        model: {
                          value: _vm.fieldsRight,
                          callback: function($$v) {
                            _vm.fieldsRight = $$v
                          },
                          expression: "fieldsRight"
                        }
                      },
                      _vm._l(_vm.fieldsRight, function(field) {
                        return _c(
                          "div",
                          {
                            key: field.id,
                            staticClass: "export-list-item mb-1"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center text-truncate"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "drag-handle text-dark mr-2" },
                                  [
                                    _c("v-icon", {
                                      attrs: { name: "buttons/dots", size: 12 }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-secondary mr-2 cursor-pointer",
                                    attrs: { title: "Открепить" },
                                    on: {
                                      click: function($event) {
                                        return _vm.unpinField(field)
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", {
                                      attrs: { name: "buttons/pin", size: 13 }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "text-small" }, [
                                  _vm._v(_vm._s(field.label))
                                ]),
                                _vm._v(" "),
                                _vm.configureRequired &&
                                field.required &&
                                field.visible
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-danger font-weight-bold ml-2"
                                      },
                                      [_vm._v("*")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-items-center",
                                staticStyle: { gap: "12px" }
                              },
                              [
                                _vm.configureRequired
                                  ? _c("b-form-checkbox", {
                                      staticClass: "m-0",
                                      attrs: { disabled: !field.visible },
                                      model: {
                                        value: field.required,
                                        callback: function($$v) {
                                          _vm.$set(field, "required", $$v)
                                        },
                                        expression: "field.required"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ant-switch-wrapper",
                                    class: {
                                      "is-disabled":
                                        _vm.visibleFields.length === 1 &&
                                        field.visible
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleField(field)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "pure-switch-track",
                                      class: { "is-checked": field.visible }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "switch-icons-overlay" },
                                      [
                                        _c("v-icon", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: field.visible,
                                              expression: "field.visible"
                                            }
                                          ],
                                          staticClass: "ml-2",
                                          staticStyle: { color: "#fff" },
                                          attrs: {
                                            name: "buttons/check",
                                            size: 11
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !field.visible,
                                              expression: "!field.visible"
                                            }
                                          ],
                                          staticClass: "flex-grow-1"
                                        }),
                                        _vm._v(" "),
                                        _c("v-icon", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !field.visible,
                                              expression: "!field.visible"
                                            }
                                          ],
                                          staticClass: "mr-2",
                                          staticStyle: { color: "#fff" },
                                          attrs: {
                                            name: "buttons/cross",
                                            size: 10
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "pure-switch-thumb",
                                      class: { "is-checked": field.visible }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.allowDelete && !field.isSeparator
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "position-relative d-flex align-items-center ml-2"
                                      },
                                      [
                                        _c("v-icon", {
                                          staticClass: "cursor-pointer",
                                          attrs: {
                                            id: "delete-btn-right-" + field.key,
                                            name: "buttons/trash",
                                            size: 14
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "b-popover",
                                          {
                                            attrs: {
                                              target:
                                                "delete-btn-right-" + field.key,
                                              triggers: "click blur",
                                              placement: "left",
                                              container: "sidebarFields"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-small font-weight-bold mb-2"
                                              },
                                              [_vm._v("Удалить колонку?")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "d-flex",
                                                staticStyle: { gap: "8px" }
                                              },
                                              [
                                                _c(
                                                  "b-btn",
                                                  {
                                                    staticClass:
                                                      "custom-btn-primary btn-sm",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.onDeleteKanbanCol(
                                                          field,
                                                          "right"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Да")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-btn",
                                                  {
                                                    staticClass:
                                                      "custom-btn-secondary btn-sm",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.$root.$emit(
                                                          "bv::hide::popover",
                                                          "delete-btn-right-" +
                                                            field.key
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Нет")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [_vm._t("list-append")], 2)
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "export-sidebar-footer px-3 py-3 border-top" },
          [
            _c(
              "div",
              {
                staticClass: "d-flex flex-wrap align-items-center",
                staticStyle: { gap: "12px" }
              },
              [
                !_vm.allowDelete
                  ? _c(
                      "b-button",
                      {
                        staticClass: "text-small p-0",
                        staticStyle: {
                          color: "#F5222D !important",
                          "text-decoration": "none !important"
                        },
                        attrs: { variant: "link" },
                        on: { click: _vm.resetColumns }
                      },
                      [_vm._v("\n          Сбросить\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.checkAll
                  ? _c(
                      "b-button",
                      {
                        staticClass: "text-small text-dark p-0",
                        staticStyle: {
                          "text-decoration": "none !important",
                          color: "#6c757d"
                        },
                        attrs: { variant: "link" },
                        on: {
                          click: function($event) {
                            return _vm.checkAllColumns(false)
                          }
                        }
                      },
                      [
                        _c("v-icon", {
                          staticClass: "mr-1 pt-1",
                          attrs: { name: "buttons/toggle_left", size: 15 }
                        }),
                        _vm._v("\n          Снять все\n        ")
                      ],
                      1
                    )
                  : _c(
                      "b-button",
                      {
                        staticClass: "text-small text-dark p-0",
                        staticStyle: { "text-decoration": "none !important" },
                        attrs: { variant: "link" },
                        on: {
                          click: function($event) {
                            return _vm.checkAllColumns(true)
                          }
                        }
                      },
                      [
                        _c("v-icon", {
                          staticClass: "mr-1 pt-1",
                          attrs: { name: "buttons/toggle_right", size: 15 }
                        }),
                        _vm._v("\n          Выбрать все\n        ")
                      ],
                      1
                    ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "custom-btn-primary ml-auto",
                    on: {
                      click: function($event) {
                        return _vm.handleSave()
                      }
                    }
                  },
                  [
                    _c("v-icon", {
                      staticClass: "mr-1",
                      attrs: { name: "buttons/save", size: 13 }
                    }),
                    _vm._v("\n          Сохранить\n        ")
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ca1fe42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ca1fe42","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utilites/commonUi/DynamicTables.vue
// module id = null
// module chunks = 